function onChangeConfirmation({ target }) {
  const submitButton = $('#submit')
  submitButton.prop('disabled', !target.checked)
}

export function jqUnsubscribeBehavior() {
  $('#unsubscribe_confirmation').on('change', onChangeConfirmation)
}
